"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbackTelemetryProcessor = void 0;
/**
 * CallbackTelemetryProcessor runs callback on all telemetry events. The
 * callback is provided with a copy of the original event.
 */
class CallbackTelemetryProcessor {
    constructor(callback) {
        this.callback = callback;
    }
    processEvent(event) {
        this.callback(Object.assign({}, event));
    }
}
exports.CallbackTelemetryProcessor = CallbackTelemetryProcessor;
//# sourceMappingURL=callback.js.map